export default {
  path: '/serve',
  meta: {
    title: '服务',
    keepAlive: true,
    tab:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/serve`),
}



// WEBPACK FOOTER //
// ./src/views/Serve/router.js